<template>
  <v-app>
    <group-card title="Steps" icon="list_alt">
      <template slot="actions">
        <loading-icon-button tooltip="Refresh" @click="fetchSteps">
          cached
        </loading-icon-button>
        <md-button class="md-primary md-sm" @click="handleStepCreation">
          New Step
          <md-tooltip md-direction="top">New Step</md-tooltip>
        </md-button>
      </template>
      <v-data-table
        class="align-table"
        :headers="headers"
        :items="steps"
        :loading="loading"
        item-value="id"
        item-key="id"
      >
        <template v-slot:item.actions="{ item }">
          <md-button class="md-primary md-sm">
            Duplicate
            <md-tooltip md-direction="top">Duplicate Step</md-tooltip>
          </md-button>
          <md-button class="md-primary md-sm" @click="editStep(item.id)">
            Edit
            <md-tooltip md-direction="top">Edit Step</md-tooltip>
          </md-button>
          <md-button class="md-danger md-sm" @click="deleteStep(item.id)">
            Delete
            <md-tooltip md-direction="top">Delete Step</md-tooltip>
          </md-button>
        </template>
      </v-data-table>
    </group-card>
  </v-app>
</template>

<script>
import { GroupCard } from "@/components";
import LoadingIconButton from "@/components/LoadingIconButton";
import ConfirmDialog from "@/components/Dialogs/ConfirmDialog.vue";
import WaitingDialog from '@/components/Dialogs/WaitingDialog.vue';
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    GroupCard,
    LoadingIconButton,
    ConfirmDialog,
    WaitingDialog,
  },
  data() {
    return {
      loading: false,
      headers: [
        { text: "Name", value: "name", align: "start" },
        { text: "Actions", value: "actions", sortable: false, width: "20%" },
      ],
    };
  },
  computed: {
    ...mapGetters("journey", ["steps"]),
  },
  methods: {
    ...mapActions("journey", ["fetchSteps", "deleteStep"]),
    handleStepCreation() {
      this.$router.push("/administration/step/new");
    },
    editStep(stepId) {
      this.$router.push(`/administration/step/${stepId}/edit`);
    },
    async deleteStep(stepId) {
      let isDeleteStep = await this.isDeleteStep();
      if(!isDeleteStep) {
        return;
      }
      this.$modal.show(WaitingDialog, {
        title: "Deleting Step",
        message: "Please wait whilst step is being deleted...",
      });
      try {
        const step = this.steps.find(step => step.id === stepId);
        if (!step) throw new Error("Step not found");
        await this.$store.dispatch("journey/deleteStep", stepId);
        this.$modal.submit();
        this.$modal.show(ConfirmDialog, {
          title: "Step Deletion Successful",
          message: `Step ${step.name} has been deleted from Zink.`,
          confirmText: "Confirm",
        });
      } catch (error) {
        this.$modal.submit();
        this.$modal.show(ConfirmDialog, {
          title: "Delete Step Failed",
          message: error.message,
          confirmText: "Confirm",
        });
      }
      await this.fetchSteps();
    },
    async isDeleteStep() {
      return this.$modal.show(ConfirmDialog, {
        title: "Delete Step",
        message: `Are you sure you want to delete this step?.`,
        confirmText: "Yes",
        cancelText: "No",
        confirmButtonColor: "md-danger",
      });
    },
    async fetchSteps() {
      this.loading = true;
      try {
        await this.$store.dispatch("journey/fetchSteps");
      } catch (error) {
        console.error("Failed to fetch steps:", error);
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    this.fetchSteps();
  },
};
</script>

<style lang="scss" scoped>
.align-table::v-deep th,
.align-table::v-deep td {
  text-align: left;
}
</style>
